import { Environment } from 'relay-runtime';
import CartUpdateEventIdMutation from '../../../mutationsModern/Cart/CartUpdateEventIdMutation';
import ShopWithCeoAddMutation from '../../../mutationsModern/User/ShopWithCeoAddMutation';
// import CartPromoCodeDeleteMutation from '../../../mutationsModern/Cart/CartPromoCodeDeleteMutation';

export type HandleExitEventProps = {
  environment: Environment;
  reassignSatelliteIfPossible?: boolean;
  callback?: () => void;
};

export function handleExitEvent({
  callback,
  environment,
  reassignSatelliteIfPossible = false,
}: HandleExitEventProps) {
  CartUpdateEventIdMutation.commit({
    environment,
    eventId: null,
    reassignSatelliteIfPossible,
    onCompleted: (updateEventIdResponse: any, updateEventIdError: {}) => {
      const ceAccountId =
        updateEventIdResponse &&
        updateEventIdResponse.cartUpdateEventId &&
        updateEventIdResponse.cartUpdateEventId.user &&
        updateEventIdResponse.cartUpdateEventId.user
          .preferredCustomerCeoAccountId;
      if (ceAccountId) {
        ShopWithCeoAddMutation.commit({
          ceAccountId,
          environment,
          onCompleted: (res: any, err: any) => {
            if (err) {
              console.error(err);
            } else {
              console.log('changed ceo', res);
            }
          },
          onError: console.error,
        });
      }

      // CartPromoCodeDeleteMutation.commit({
      //   environment,
      //   promoCode: 'CASE4CAUSE',
      //   noEventIdRemove: true,
      //   onCompleted: (response: {}, error: {}) => {
      //     if (callback) {
      //       callback();
      //     }
      //     console.log('response deleting promo', response);
      //   },
      //   onError: (transaction: {}) => {
      //     console.log('error for deleting promo', transaction);
      //   },
      // });
    },
    onError: (transaction: {}) => {
      console.log('error for update event id', transaction);
    },
  });
}
